/* global axios */
import ApiClient from './ApiClient';

class LostReasonsAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true, apiVersion: 'v2' });
  }

  urlFor(pipelineId) {
    return `${this.url}/${pipelineId}/lost_reasons`;
  }

  index(pipelineId) {
    return axios.get(this.urlFor(pipelineId));
  }

  create(pipelineId, payload) {
    return axios.post(this.urlFor(pipelineId), { lost_reason: payload });
  }

  update(pipelineId, id, payload) {
    return axios.patch(`${this.urlFor(pipelineId)}/${id}`, { lost_reason: payload });
  }

  destroy(pipelineId, id) {
    return axios.delete(`${this.urlFor(pipelineId)}/${id}`);
  }
}

export default new LostReasonsAPI();
